module.exports = __webpack_public_path__ + "img/2.03fe5591.png";